export default __webpack_public_path__ + "static/39-2f9d1656d58ac3205619628fb184c6d3.png";